var _Circle, _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgDayCollected = function SvgDayCollected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "url(#day-collected_svg__a)",
    stroke: "#0D290D"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 5.5 4.667 7 8 4"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "day-collected_svg__a",
    x1: 5.5,
    x2: 5.5,
    y1: 0,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#5CDE52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1A851F"
  })))));
};
export default SvgDayCollected;